import { useState, useEffect, useCallback } from "react";
import { fetchSymbols } from "./googleSheets";
import { SYMBOLS } from "./symbols";

/* ── Statik veriden fallback listesi ─────────────────────── */
const CAT_ORDER = ["BIST", "NASDAQ", "KRIPTO", "KMADEN"];
const FALLBACK  = CAT_ORDER.flatMap((cat) =>
  (SYMBOLS[cat] || []).map((s) => ({ ...s, category: cat }))
);

/* Module-level cache: sayfa yenilenmeden tekrar fetch olmaz */
let _cache = null;

/* ── Hook ─────────────────────────────────────────────────── */
export const useSymbols = () => {
  /* Sheets yüklenene kadar statik symbols.js verisiyle başla */
  const [symbols, setSymbols] = useState(_cache || FALLBACK);

  useEffect(() => {
    if (_cache) return;
    fetchSymbols().then((data) => {
      if (data.length > 0) {
        _cache = data;
        setSymbols(data);
      }
    });
  }, []);

  /* Autocomplete araması — ilk 8 sonuç */
  const filterAll = useCallback(
    (query) => {
      if (!query?.trim()) return [];
      const q = query.trim().toUpperCase();
      return symbols
        .filter((s) => s.symbol.startsWith(q) || s.name.toUpperCase().includes(q))
        .slice(0, 8);
    },
    [symbols]
  );

  /* Sembolden kategori algıla */
  const detectCat = useCallback(
    (symbol) => {
      if (!symbol) return null;
      const found = symbols.find((s) => s.symbol === symbol.trim().toUpperCase());
      return found?.category ?? null;
    },
    [symbols]
  );

  return { filterAll, detectCat };
};
